import { ApplicationUser } from "./application-user.model";

	/**
	 * @description
	 *  Modelo de empaquetado de un pedido.
	 *
	 * @see gigot-backend/Models/Orders/OrderBasket.cs
	 */

export class OrderBasket {

	public applicationUser: ApplicationUser;
	public applicationUserId: string;
	public basketId: number;
	public basketLabel: string;
	public basketNumber: number;
	public id: number;
	public isScanned: boolean;
	public orderId: number;
	public totalMaterials: number;

	/**
	 * @description
	 *	Construye un empaquetado de pedido con una semántica vacía. Nótese que
	 *	no es lo mismo que construir un empaquetado con valores por defecto.
	 *	Las reglas generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un empaquetado vacío.
	 */
	public static empty(): OrderBasket {
		const orderBasket: OrderBasket = new OrderBasket();
		orderBasket.applicationUser = ApplicationUser.empty();
		orderBasket.applicationUserId = "";
		orderBasket.basketId = undefined;
		orderBasket.basketLabel = "";
		orderBasket.basketNumber = undefined;
		orderBasket.id = undefined;
		orderBasket.isScanned = false;
		orderBasket.orderId = undefined;
		orderBasket.totalMaterials = undefined;
		return orderBasket;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicOrderBasket
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicOrderBasket: OrderBasket): OrderBasket {
		if (!anemicOrderBasket) return undefined;
		const orderBasket: OrderBasket = OrderBasket.empty();
		orderBasket.applicationUser = ApplicationUser.from(anemicOrderBasket.applicationUser);
		orderBasket.applicationUserId = anemicOrderBasket.applicationUserId;
		orderBasket.basketId = anemicOrderBasket.basketId;
		orderBasket.basketLabel = anemicOrderBasket.basketLabel;
		orderBasket.basketNumber = anemicOrderBasket.basketNumber;
		orderBasket.id = anemicOrderBasket.id;
		orderBasket.isScanned = anemicOrderBasket.isScanned;
		orderBasket.orderId = anemicOrderBasket.orderId;
		orderBasket.totalMaterials = anemicOrderBasket.totalMaterials;
		return orderBasket;
	}
}
